import { ele } from "cables-shared-client";
import api from "./api.js";
import web from "./index.js";

export default class Projects
{
    getTagsFromProjects(projects)
    {
        const tags = {};
        const tagArr = [];

        for (const i in projects)
        {
            if (projects[i].tags)
                for (let j = 0; j < projects[i].tags.length; j++)
                {
                    const t = projects[i].tags[j];
                    if (t != name)
                        if (tags.hasOwnProperty(t)) tags[t]++;
                        else tags[t] = 0;
                }
        }

        for (const index in tags)
        {
            tagArr.push({
                "name": index,
                "num": tags[index],
                "fontsize": tags[index] * 2 + 12
            });
        }

        tagArr.sort((a, b) => { return a.num - b.num; });

        return tagArr;
    }

    getUserProjects(userId, admin, limit, offset = 0)
    {
        let url = "user/" + userId + "/projects";
        if (admin) url = "admin/user/" + userId + "/projects";

        limit = Number(limit);
        offset = Number(offset);
        if (limit || limit === 0)
        {
            url += "?l=" + limit;
        }
        if (offset)
        {
            url += "&o=" + offset;
        }

        api.get(url, (result) =>
        {
            let html = "";
            let displayedDate = "published";
            if (admin) displayedDate = "updated";
            for (const i in result.projects)
            {
                const project = result.projects[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": displayedDate });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }

            document.getElementById("projects").innerHTML = html;

            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId("results_container"), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "";
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "?l=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&o=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch + window.location.hash;
                });
            }
        });
    }

    createPatchFromBackup(versionId, menuElement)
    {
        const errorEle = ele.byId("errors");
        if (errorEle) ele.hide(errorEle);
        const formerText = menuElement.innerText;
        menuElement.innerText = "working...";
        api.get("projectversion/recover/" + versionId, (result) =>
        {
            menuElement.innerText = formerText;
            if (result && result.data && result.data.projectId)
            {
                window.open("/edit/" + result.data.projectId);
            }
        }, (e) =>
        {
            menuElement.innerText = formerText;
            if (errorEle)
            {
                errorEle.innerText = "failed to create new patch: " + e.msg;
                ele.show(errorEle);
            }
        });
    }

    deleteBackup(versionId, menuElement)
    {
        const errorEle = ele.byId("errors");
        if (errorEle) ele.hide(errorEle);
        const formerText = menuElement.innerText;
        menuElement.innerText = "working...";
        api.delete("projectversion/delete/" + versionId, {}, () =>
        {
            menuElement.innerText = formerText;
            window.location.reload();
        }, (e) =>
        {
            menuElement.innerText = formerText;
            errorEle.innerText = "failed to delete backup:" + e.msg;
            ele.show(errorEle);
        });
    }

    keepBackup(versionId, menuElement)
    {
        const errorEle = ele.byId("errors");
        if (errorEle) ele.hide(errorEle);
        const formerText = menuElement.innerText;
        menuElement.innerText = "working...";
        api.get("projectversion/keep/" + versionId, (result) =>
        {
            menuElement.innerText = formerText;
            window.location.reload();
        }, (e) =>
        {
            menuElement.innerText = formerText;
            errorEle.innerText = "failed to keep backup:" + e.msg;
            ele.show(errorEle);
        });
    }

    getBackupsTable(baseUrl, targetElement, showPatchNames = false, quotaPosition = "top")
    {
        const url = new URL(window.location.href);
        const order = url.searchParams.get("or") || "created";
        const limit = url.searchParams.get("l") || 20;
        const offset = url.searchParams.get("o") || 0;

        let apiUrl = web.tabs.addPagination(baseUrl + "?or=" + order, limit, offset);
        api.get(apiUrl, (res) =>
        {
            if (res && res.data && res.data.backups)
            {
                const backups = res.data.backups;
                const quota = res.data.quota;
                const quotaEl = web.getHandleBarHtml("backups_quota", { "quota": quota });
                web.setHandleBarHtml("backups_table", { "backups": backups, "quota": quota, "showPatch": showPatchNames, "sortable": !web.isIframe }, targetElement);
                if (quotaPosition === "top")
                {
                    targetElement.innerHTML = quotaEl + targetElement.innerHTML;
                }
                else
                {
                    targetElement.innerHTML += quotaEl;
                }
                web.tabs.initPagination(targetElement, res.pagination, res.pagination.limit, res.pagination.offset);
                web.tables.initTables(targetElement.querySelectorAll("table.sortable"));

                const orderTabs = ele.byQueryAll("#order-tab-bar li");
                orderTabs.forEach((orderTab) =>
                {
                    if (orderTab.classList.contains(order)) orderTab.classList.add("active");
                    orderTab.addEventListener("click", () =>
                    {
                        const sort = orderTab.dataset.sort;
                        window.location.search = "?or=" + sort;
                    });
                });
            }
        }, (err) =>
        {
            targetElement.innerText = "failed to get backups: " + err.msg;
        });
    }

    requestAccess(projectId, permission, cbSuccess = null, cbError = null)
    {
        api.post("patchinvite/request/" + projectId + "/" + permission, {}, cbSuccess, cbError);
    }
}
